__turbopack_context__.v({
  "active": "Q7ciHq_active",
  "tabButton": "Q7ciHq_tabButton",
  "tabPanel": "Q7ciHq_tabPanel",
  "tabsHeader": "Q7ciHq_tabsHeader",
  "tabsPanels": "Q7ciHq_tabsPanels",
});
